import React from 'react';
import { MdAddCircle } from 'react-icons/md';
import { Link, useParams } from 'react-router-dom';

const ModuleCardNew = ({ pos }: any) => {
  const { id } = useParams();
  return (
    <Link
      to={`/training/${id}/modules/new?pos=${pos}`}
      className='bg-white mb-5 w-4/6 h-16 p-2 rounded-lg shadow-lg text-purple-700 font-medium flex items-center justify-center'
    >
        <MdAddCircle size={25} className='mr-2'/>
        Nouveau Module
    </Link>
    )
}

export default ModuleCardNew;
